/* ============================================================
   ToTheLove — PDP : UGC vidéos
   ------------------------------------------------------------
   Custom element <ttl-ugc>. Réinit auto au shopify:section:load
   (le navigateur appelle connectedCallback à l'insertion DOM).
   Scoping strict via [data-ttl-ugc*].

   - clic sur une vidéo = lecture / pause ;
   - UNE SEULE vidéo joue à la fois (on met les autres en pause) ;
   - SON activé : le clic est un geste utilisateur → on dé-mute
     avant play() (fallback muet si le navigateur refuse) ;
   - clic + glisser (souris) = scroll horizontal de la piste, sans
     déclencher le play/pause (seuil de déplacement + suppression du
     clic de fin de glissement) ;
   - tactile : scroll natif, tap = play/pause.
   ============================================================ */
(function () {
  if (customElements.get('ttl-ugc')) return;

  var DRAG_THRESHOLD = 8; // px avant de considérer un glissement plutôt qu'un clic

  class TtlUgc extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.track = this.querySelector('[data-ttl-ugc-track]');
      this.medias = Array.prototype.slice.call(
        this.querySelectorAll('[data-ttl-ugc-media]')
      );
      this.labelPlay = this.dataset.ttlLabelPlay || '';
      this.labelPause = this.dataset.ttlLabelPause || '';

      // Vrai pendant le clic qui suit immédiatement un glissement souris :
      // on le « consomme » pour ne pas toggler une vidéo par accident.
      this._suppressClick = false;

      this.medias.forEach(function (media) {
        var video = media.querySelector('[data-ttl-ugc-video]');
        if (!video) return;

        // État visuel + a11y pilotés par les events natifs (robuste, gère
        // aussi une pause déclenchée par le navigateur ou la fin de lecture).
        video.addEventListener('play', this._setState.bind(this, media, true));
        video.addEventListener('pause', this._setState.bind(this, media, false));
        video.addEventListener('ended', this._setState.bind(this, media, false));

        media.addEventListener('click', this._onMediaClick.bind(this, media, video));
      }, this);

      if (this.track) this._bindDrag();
    }

    _setState(media, playing) {
      media.setAttribute('data-ttl-ugc-state', playing ? 'playing' : 'paused');
      media.setAttribute('aria-label', playing ? this.labelPause : this.labelPlay);
    }

    _onMediaClick(media, video) {
      if (this._suppressClick) {
        this._suppressClick = false;
        return; // c'était la fin d'un glissement, pas un clic
      }
      if (video.paused) {
        this._playOne(video);
      } else {
        video.pause();
      }
    }

    _playOne(video) {
      // Une seule à la fois : on met toutes les autres en pause.
      this.medias.forEach(function (m) {
        var v = m.querySelector('[data-ttl-ugc-video]');
        if (v && v !== video && !v.paused) v.pause();
      });

      video.muted = false; // son activé (geste utilisateur)
      video.volume = 1;

      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {
          // Si le navigateur refuse la lecture avec son, on retombe en
          // muet pour au moins jouer l'image (ne devrait pas arriver sur clic).
          video.muted = true;
          video.play().catch(function () {});
        });
      }
    }

    _bindDrag() {
      var self = this;
      var track = this.track;
      var down = false;
      var isMouse = false;
      var startX = 0;
      var startScroll = 0;
      var moved = false;

      track.addEventListener('pointerdown', function (e) {
        self._suppressClick = false; // repart propre à chaque nouvelle interaction
        isMouse = e.pointerType === 'mouse';
        if (!isMouse) return; // tactile : on laisse le scroll natif
        down = true;
        moved = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        // IMPORTANT : on ne capture PAS le pointeur ici. Capturer dès le
        // pointerdown ferait dispatcher le `click` sur la piste au lieu du
        // bouton vidéo → le play ne se déclencherait jamais. On capture
        // uniquement quand un vrai glissement a commencé (voir pointermove).
      });

      track.addEventListener('pointermove', function (e) {
        if (!down || !isMouse) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > DRAG_THRESHOLD) {
          moved = true;
          self._suppressClick = true; // le clic de fin de glissement sera ignoré
          track.setAttribute('data-ttl-grabbing', ''); // désactive le snap (CSS) + curseur
          try {
            track.setPointerCapture(e.pointerId); // suit le pointeur même hors piste
          } catch (err) {}
        }
        if (moved) {
          e.preventDefault(); // évite la sélection de texte / drag d'image pendant le scroll
          track.scrollLeft = startScroll - dx;
        }
      });

      function endDrag(e) {
        if (!down) return;
        down = false;
        track.removeAttribute('data-ttl-grabbing');
        if (e && e.pointerId != null) {
          try {
            track.releasePointerCapture(e.pointerId);
          } catch (err) {}
        }
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
    }
  }

  customElements.define('ttl-ugc', TtlUgc);
})();
